<template>
  <v-container id="cri-items" class="custom-container">
    <v-alert v-if="invoiceItems.length === 0" type="info" outlined class="mb-3">
      Select an invoice above to load its items.
    </v-alert>

    <v-data-table v-if="criItems.length > 0" :headers="headers" :items="criItems" :hide-default-footer="true" :disable-sort="true" :hide-default-header="true">
      <template v-slot:header="{ props }">
        <thead>
          <tr>
            <th v-for="header in props.headers" :key="header.text" class="custom-header" style="border-bottom: thin solid rgb(0 0 0 / 0%);">
              <p>{{ header.text }}</p>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ item, index }">
        <tr :key="index">
          <td class="text-left caption">{{ item.product_code }}</td>
          <td class="text-left caption">{{ item.product_name || '-' }}</td>
          <td class="text-left caption">{{ item.batch_code || '-' }}</td>
          <td class="text-left caption">{{ item.quantity }}</td>
          <td class="text-left caption">{{ item.unit_price }}</td>
          <td class="text-left caption">{{ item.tax_percent || 0 }}%</td>
          <td class="text-left caption">{{ item.discount || 0 }}%</td>
          <td>
            <v-text-field class="narrow-field" :value="item.quantity_returned" @input.native="onQtyNative(item, $event)" type="number" dense min="0" outlined :error="Number(item.quantity_returned) > Number(item.quantity)"></v-text-field>
          </td>
          <td>
            <v-select v-model="item.condition" :items="conditions" dense outlined clearable placeholder="Condition" item-text="text" item-value="value" class="condition-field"></v-select>
          </td>
          <td>
            <v-text-field v-model="item.reason" dense outlined placeholder="Reason for return" class="reason-field"></v-text-field>
          </td>
          <td class="text-left caption">{{ (Number(item.quantity_returned) * Number(item.unit_price)).toFixed(2) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  props: { invoiceItems: { type: Array, default: () => [] } },
  data() {
    return {
      headers: [
        { text: "Product Code", value: "product_code" },
        { text: "Product Name", value: "product_name" },
        { text: "Batch", value: "batch_code" },
        { text: "Inv Qty", value: "quantity" },
        { text: "Unit Price", value: "unit_price" },
        { text: "Tax %", value: "tax_percent" },
        { text: "Disc %", value: "discount" },
        { text: "Qty Returned", value: "quantity_returned" },
        { text: "Condition", value: "condition" },
        { text: "Reason", value: "reason" },
        { text: "Total", value: "total_price" },
      ],
      criItems: [],
      conditions: [
        { text: "Good", value: "Good" },
        { text: "Damaged", value: "Damaged" },
        { text: "Defective", value: "Defective" },
      ],
    };
  },
  watch: {
    invoiceItems: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.criItems = newVal.map((item) => ({
            product_code: item.product_code,
            product_name: item.product_name,
            product_id: item.product_id,
            batch_id: item.batch_id,
            batch_code: item.batch_code,
            quantity: item.quantity,
            quantity_returned: 0,
            unit_price: item.unit_price || 0,
            tax_percent: item.tax_percent || 0,
            discount: item.discount || 0,
            condition: "Good",
            reason: "",
          }));
        } else {
          this.criItems = [];
        }
      },
    },
    criItems: {
      deep: true,
      handler(newItems) {
        this.$emit("items", newItems);
      },
    },
  },
  methods: {
    onQtyNative(item, e) {
      const max = Number(item.quantity);
      const raw = e.target.value;
      const num = Number(raw);
      if (num > max || num < 0 || raw === '-' || raw === '' || isNaN(num)) {
        const corrected = Math.min(Math.max(num || 0, 0), max);
        item.quantity_returned = corrected;
        e.target.value = corrected;
      } else {
        item.quantity_returned = num;
      }
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset { border-color: rgba(192, 0, 250, 0.215); border-radius: 10px; }
.custom-container { width: 100%; max-width: 100%; padding: 0 !important; margin: 0 !important; }
.v-data-table td { padding: 8px 6px !important; text-align: center; vertical-align: middle; white-space: nowrap; }
.v-data-table th { padding: 8px 6px !important; text-align: center; }
.narrow-field { max-width: 110px; min-width: 90px; width: 90px; }
.condition-field { max-width: 200px; min-width: 180px; width: 180px; }
.reason-field { max-width: 400px; min-width: 350px; width: 350px; }
.caption { font-size: 0.85rem; }
</style>
